import PropTypes from 'prop-types';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { BLOCKS } from '@contentful/rich-text-types';

const options = {
	renderNode: {
		[BLOCKS.HEADING_1]: (node, children) => (
			<h1 className="typography typography--h1">{children}</h1>
		),
		[BLOCKS.HEADING_2]: (node, children) => (
			<h2 className="typography typography--h2">{children}</h2>
		),
		[BLOCKS.HEADING_3]: (node, children) => (
			<h3 className="typography typography--h3">{children}</h3>
		),
		[BLOCKS.HEADING_4]: (node, children) => (
			<h4 className="typography typography--h4">{children}</h4>
		),
		[BLOCKS.HEADING_5]: (node, children) => (
			<h5 className="typography typography--h5">{children}</h5>
		),
		[BLOCKS.PARAGRAPH]: (node, children) => (
			<p className="typography typography--body-big typography--black">
				{children}
			</p>
		),
	},
};

const RichText = ({
	content,
	textAlignment,
	contentWidth,
	paddingTop,
	paddingBottom,
}) => {
	const alignmentClassMap = {
		left: 'rich-text--left',
		right: 'rich-text--right',
		center: 'rich-text--center',
	};
	const alignmentClass = alignmentClassMap[textAlignment.toLowerCase()];

	const widthClassMap = {
		main: 'rich-text--content--main',
		small: 'rich-text--content--small',
		'full width': 'rich-text--content--full',
	};
	const widthClass = widthClassMap[contentWidth.toLowerCase()];

	const getPaddingClassMap = (paddingType) => ({
		medium: `rich-text--spacing-${paddingType}--medium`,
		small: `rich-text--spacing-${paddingType}--small`,
		none: `rich-text--spacing-${paddingType}--none`,
	});
	const paddingTopClass = getPaddingClassMap('top')[paddingTop.toLowerCase()];
	const paddingBottomClass = getPaddingClassMap('bottom')[paddingBottom.toLowerCase()];

	return (
		<div
			className={`section rich-text ${alignmentClass} ${paddingTopClass} ${paddingBottomClass}`}
		>
			<div className={`section__content ${widthClass}`}>
				{renderRichText(content, options)}
			</div>
		</div>
	);
};

const paddingType = PropTypes.oneOf(['Medium', 'Small', 'None']);

RichText.propTypes = {
	content: PropTypes.shape({
		raw: PropTypes.string,
	}).isRequired,
	textAlignment: PropTypes.oneOf(['Left', 'Right', 'Center']),
	contentWidth: PropTypes.oneOf(['Main', 'Small', 'Full Width']),
	paddingTop: paddingType,
	paddingBottom: paddingType,
};

RichText.defaultProps = {
	textAlignment: 'Left',
	paddingTop: 'Medium',
	paddingBottom: 'Medium',
};

export default RichText;
